module.exports = __webpack_public_path__ + "static/img/taian3.a9dee950.jpg";